import { useSearchMasterDataUnspsc } from '@curvo/apollo'
import LoadingIndicator from '@curvo/common-ui/dist/components/Loading/Spinner'
import { LabeledValue, SelectProps } from 'antd/lib/select'
import { debounce } from 'lodash'
import React, { useState } from 'react'
import { StyledSelect, StyledSelectPropsType } from '../../Update/components/Select/common'

export const UnspscSelector: React.FunctionComponent<
  SelectProps<LabeledValue> & StyledSelectPropsType & { fullData?: boolean }
> = props => {
  const [searchText, setSearchText] = useState('')

  const { data, loading } = useSearchMasterDataUnspsc({
    variables: { input: { search: searchText } },
    skip: !searchText,
  })

  const unspscs = (data && data.searchMedUnspsc) || []

  return (
    <StyledSelect
      onSearch={debounce(setSearchText, 800)}
      loading={loading}
      labelInValue
      showSearch
      filterOption={false}
      showArrow={false}
      defaultActiveFirstOption={false}
      placeholder="Type to start searching"
      notFoundContent={loading ? <LoadingIndicator /> : 'No Data'}
      {...props}>
      {unspscs.map(item => (
        <StyledSelect.Option key={item}>{item}</StyledSelect.Option>
      ))}
    </StyledSelect>
  )
}
